import { render, staticRenderFns } from "./profileDetail.vue?vue&type=template&id=7f52d2f0&scoped=true"
import script from "./profileDetail.vue?vue&type=script&lang=js"
export * from "./profileDetail.vue?vue&type=script&lang=js"
import style0 from "./profileDetail.vue?vue&type=style&index=0&id=7f52d2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f52d2f0",
  null
  
)

export default component.exports